import React from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, Clock } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <section id="contact" className="py-24 bg-[#0f1d35]" data-id="element-11" data-mp="317cxe28ek586">
      <div className="max-w-7xl mx-auto px-6" data-id="element-12" data-mp="2w7qk5sskqozd">
        <div className="grid md:grid-cols-2 gap-16 items-center" data-id="element-13" data-mp="2w8s4yoze6pua">
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-14" data-mp="3swg55rzhzxpk">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-15" data-mp="ggcf5qi61dow">
              {t.contact.title}
            </h2>

            <div className="space-y-8" data-id="element-16" data-mp="bpck6qslx5p1">
              <div className="flex items-start gap-4" data-id="element-17" data-mp="bob7khvy0b57">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-18" data-mp="3jv2yd6r2zo63">
                  <MapPin size={24} data-id="element-19" data-mp="3ouo3jywugsr9" />
                </div>
                <div data-id="element-20" data-mp="3ou5yccs7f477">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-21" data-mp="3owihgt9p7klu">
                    {t.contact.address}
                  </h3>
                  <p className="text-white/60" data-id="element-22" data-mp="3f4csztinnlbe">
                    <a href="https://aviatickyklubtlustice.cz/" target="_blank" rel="noopener noreferrer" className="hover:text-[#38bdf8] transition-colors" data-id="element-23" data-mp="3f31k5facrndf">
                      Aviatický klub Tlustice, z.s.
                    </a>
                    <br data-id="element-24" data-mp="2w5gvo9bi2qtc" />
                    č.p. 258
                    <br data-id="element-25" data-mp="2w6a4rgxxlsen" />
                    268 01 Tlustice
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-26" data-mp="uenb17mnnjeh">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-27" data-mp="ue3t3qx08v0g">
                  <Phone size={24} data-id="element-28" data-mp="23cn670jnrjp1" />
                </div>
                <div data-id="element-29" data-mp="2397sa11q0gp7">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-30" data-mp="1ybzianqq7iz1">
                    {t.contact.phone}
                  </h3>
                  <p className="text-white/60 hover:text-[#38bdf8] transition-colors cursor-pointer" data-id="element-31" data-mp="1ubp2ykh1ng7i">
                    +420 606 730 374
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-32" data-mp="2m1k0v5iywe7s">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-33" data-mp="2i0qa84e54lb7">
                  <Mail size={24} data-id="element-34" data-mp="2i2uguu3fbyf6" />
                </div>
                <div data-id="element-35" data-mp="2d8gqj63mchhd">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-36" data-mp="2d7x5vhml3ezn">
                    {t.contact.email}
                  </h3>
                  <p className="text-white/60 hover:text-[#38bdf8] transition-colors cursor-pointer" data-id="element-37" data-mp="35pstthsc4o8c">
                    info@aviatickyklubtlustice.cz
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-38" data-mp="38babah0750t7">
                <div className="p-3 bg-[#0a1628] rounded-lg text-[#38bdf8]" data-id="element-39" data-mp="38clhenh46knh">
                  <Clock size={24} data-id="element-40" data-mp="3da3o077nsnsb" />
                </div>
                <div data-id="element-41" data-mp="3i857gt8zyp4b">
                  <h3 className="text-white font-semibold text-lg mb-1" data-id="element-42" data-mp="3i7lt1mik2iv1">
                    {t.contact.hours}
                  </h3>
                  <p className="text-white/60" data-id="element-43" data-mp="3m85ngibqv8dh">{t.contact.hoursValue}</p>
                  <p className="text-white/60" data-id="element-44" data-mp="3r8jsrslyo47t">{t.contact.hoursNote}</p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Map Placeholder */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="h-[400px] w-full" data-id="element-45" data-mp="4uti0o0neyf9">
            <a href="https://mapy.com/cs/turisticka?q=N49%C2%B050%E2%80%9953%2C00%E2%80%9D%20E013%C2%B053%E2%80%9938%2C00%E2%80%9D&source=coor&id=13.893888888888888%2C49.84805555555556&ds=2&x=13.8911369&y=49.8486886&z=15" target="_blank" rel="noopener noreferrer" className="block h-full w-full bg-[#0a1628] rounded-2xl border border-white/10 relative overflow-hidden group cursor-pointer hover:border-[#38bdf8]/40 transition-colors" data-id="element-46" data-mp="5614xz04kz3w">
              {/* Map Placeholder Visuals */}
              <div className="absolute inset-0 bg-[#0f1d35] opacity-50" data-id="element-47" data-mp="3edu3gbo7ya5q" />
              <div className="absolute inset-0 flex flex-col items-center justify-center" data-id="element-48" data-mp="3scblptvcuug9">
                <div className="w-16 h-16 bg-[#38bdf8]/20 rounded-full flex items-center justify-center mb-4 backdrop-blur-sm group-hover:scale-110 transition-transform duration-300" data-id="element-49" data-mp="3nbnx1eulmpp7">
                  <MapPin size={32} className="text-[#38bdf8]" data-id="element-50" data-mp="12mzuf9mndwft" />
                </div>
                <h3 className="text-white font-bold text-xl mb-2" data-id="element-51" data-mp="2kjbpjv6eq6vh">
                  {t.contact.mapTitle}
                </h3>
                <p className="text-white/50 text-sm" data-id="element-52" data-mp="2pjpmah2k5ue7">{t.contact.mapNote}</p>
              </div>

              {/* Grid lines for "map" feel */}
              <div className="absolute inset-0 pointer-events-none" style={{
              backgroundImage: 'linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px)',
              backgroundSize: '40px 40px'
            }} data-id="element-53" data-mp="2blhusooajlaf" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}